import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { IconComponent } from '@atoms/icon/icon.component';
import { ImageComponent } from '@atoms/image/image.component';
import { UnderlineLinkComponent } from '@atoms/underline-link/underline-link.component';
import { PopoverComponent } from '@molecules/popover/popover.component';
import { PopoverDirective } from '@directives/popover.directive';
import { GoogleTranslateService } from '@services/google-translate.service';
import { PopoverService } from '@services/popover.service';
import { NavigationService } from '@services/navigation.service';
import { LinkPipe } from '@pipes/link.pipe';

@Component({
  selector: 'app-footer',
  imports: [NgClass, RouterModule, TranslateModule, IconComponent, ImageComponent, UnderlineLinkComponent, PopoverComponent, PopoverDirective, LinkPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  public globals = inject(Globals);
  public googleTranslateService = inject(GoogleTranslateService);
  public popoverService = inject(PopoverService);
  public navigationService = inject(NavigationService);

  translate(language: string): void {
    this.googleTranslateService.setGoogleTranslator(language);
    this.popoverService.close();
  }
}
